var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.clientView === 'viewsurf')?_c('VSGraph',{staticClass:"marginal",attrs:{"video":{uuid: '*'}}}):_vm._e(),_c('CompleteAnalytics',{staticClass:"marginal",attrs:{"video":{uuid: '*'}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }